import { mockApiClient } from "./apiClient";
import { bidCreateSchema, disputeCreateSchema, holdRequestSchema, orderCreateSchema, type BidCreateInput, type DisputeCreateInput, type HoldRequestInput, type OrderCreateInput } from "../schemas/orderSchemas";

export const orderService = {
  listOrders: () => mockApiClient.listOrders(),
  getOrder: (id: string) => mockApiClient.getOrder(id) ?? mockApiClient.listOrders()[0],
  createOrder: (input: OrderCreateInput) => {
    const parsed = orderCreateSchema.parse(input);
    const listing = mockApiClient.getListing(parsed.listingId) ?? mockApiClient.listListings()[0];
    return mockApiClient.createOrder({
      listingId: parsed.listingId,
      buyerId: parsed.buyerId,
      sellerId: listing.sellerId,
      status: "payment_pending",
      total: listing.unitPrice * parsed.quantity,
      nextAction: "Buyer confirms ACH and packet acknowledgement",
    });
  },
  listBids: () => mockApiClient.listBids(),
  createBid: (input: BidCreateInput) => mockApiClient.createBid({ ...bidCreateSchema.parse(input), status: "submitted" as const }),
  acceptBid: (id: string) => mockApiClient.updateBidStatus(id, "accepted"),
  rejectBid: (id: string) => mockApiClient.updateBidStatus(id, "rejected"),
  listHoldRequests: () => mockApiClient.listHoldRequests(),
  createHoldRequest: (input: HoldRequestInput) => mockApiClient.createHoldRequest({ ...holdRequestSchema.parse(input), status: "requested" as const }),
  approveHoldRequest: (id: string) => mockApiClient.updateHoldRequestStatus(id, "approved"),
  releaseHoldRequest: (id: string) => mockApiClient.updateHoldRequestStatus(id, "released"),
  createDispute: (input: DisputeCreateInput) => ({ id: `DSP-${Date.now()}`, ...disputeCreateSchema.parse(input), status: "open" as const }),
};
